
import axios from 'axios';
import qs from 'qs'; // 引入qs模块，用来序列化post类型的数据


const instance = axios.create({
  baseURL: process.env.NODE_ENV === 'development' ? '/dev-api' : '', // 请求地址url 相对路径
  // timeout: 30000, // 超时中断
  withCredentials: true
});
// 设置默认请求头
axios.defaults.headers.post['Content-Type'] =
  'application/x-www-form-urlencoded;charset=UTF-8';

// 请求拦截器
instance.interceptors.request.use(
  function(config) {
    return config;
  },
  function(error) {
    return Promise.reject(error);
  }
);
// 响应拦截器
instance.interceptors.response.use(
  function(response) {
      return response;
  },
  function(error) {
    return Promise.reject(error);
  }
);

// 请求封装
const httpRequest = {
  // get请求
  get(url, params, otherConfigs) {
    return new Promise((resolve, reject) => {
      instance({
        method: 'get',
        url: url,
        params: params,
        ...otherConfigs
      })
        .then((response) => {
          // 请求成功
          console.log(response, '请求成功');

          resolve(response.data);
        })
        .catch((err) => {
          // 请求失败
          // console.log(err, '请求失败')
          reject(err);
        });
    });
  },
  // post请求
  post(url, data, otherConfigs) {
    return new Promise((resolve, reject) => {
      instance({
        method: 'post',
        url: url,
        data: otherConfigs && otherConfigs.cancelQs ? data : qs.stringify(data),
        ...otherConfigs
      })
        .then(async(response) => {
          // 请求成功
          console.log(response, url, data);
          resolve(response?.data || data);
        })
        .catch((err) => {
          // 请求失败
          reject(err);
        });
    });
  }
};

export { httpRequest };
